// Module
var code = "<canvas class=\"signature\"></canvas>\n\n<div id=\"signatureControls\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\">\n    <md-button class=\"btnShort\" ng-click=\"clear()\">CLEAR</md-button>\n    <md-button class=\"btnShort\" ng-click=\"save()\">SAVE</md-button>\n</div>\n";
// Exports
module.exports = code;